import helper from '@/libs/forms';


const ethnicityOptions = [
  { value: 'hispanic_or_latino', name: 'Hispanic / Latino' },
  { value: 'other', name: 'Not Hispanic / Latino' },
];

const hispanicOptions = [
  { id: 'mexican', text: 'Mexican' },
  { id: 'puerto_rican', text: 'Puerto Rican' },
  { id: 'cuban', text: 'Cuban' },
  { id: 'other', text: 'Other' },
];


const getEthinicityFields = () => {
  /* eslint no-param-reassign: ["error", { "props": false }] */
  const ethnicityField = helper.radios(
    'Ethnicity', 'ethnicity', true, ethnicityOptions, 12, 'bold-label', null,
  );
  ethnicityField.onChanged = (model, newVal) => {
    if (newVal === 'other') {
      model.origin = null;
    }
  };


  const originField = helper.multipleCheckbox(
    'Specify', 'origin', hispanicOptions,
    true, 12, '', true, model => model.ethnicity === 'hispanic_or_latino',
  );
  originField.onChanged = (model, newVal) => {
    if (!newVal.includes('other')) {
      model.description = null;
    }
  };

  return [
    ethnicityField,
    originField,
    helper.simpleInput(
      'text', 'Describe', null, 'description', true, 12, null,
      model => (Array.isArray(model.origin) && model.origin.includes('other')),
    ),
  ];
};


export default {
  schema: { fields: getEthinicityFields() },
  options: helper.options('demographics-ethnicity-', false),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/demographics/schemas/ethnicity.js